var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import ShopActivityService from '../../api/ShopActivityPoster';
import GLOBAL_VUE from '../../globalVue';
import VueDragResize from 'vue-drag-resize';
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import TableListDialog from "./components/TableDialog.vue";
import DragItem from './components/DragItem.vue';
var defaultRects = [
    [{
            'width': 60,
            'height': 60,
            'top': 10,
            'left': 100,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img',
            'src': '/static/image/poster/poster_icon.png'
        },
        {
            'width': 180,
            'height': 80,
            'top': 100,
            'left': 30,
            'fontSize': 14,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#000',
            'active': false,
            'type': 'input',
            'value': '公司介绍：我们是一家XX公司，提供XXX货品'
        },
        {
            'width': 50,
            'height': 50,
            'top': 252,
            'left': 102,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img_qrcode',
            'src': '/static/image/poster/poster_qrcode.png'
        },
        {
            'width': 180,
            'height': 25,
            'top': 310,
            'left': 58,
            'fontSize': 10,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#fff',
            'active': false,
            'type': 'input',
            'value': '长按二维码，进入商城'
        },
    ],
    [{
            'width': 60,
            'height': 60,
            'top': 10,
            'left': 100,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img',
            'src': '/static/image/poster/poster_icon.png'
        },
        {
            'width': 180,
            'height': 40,
            'top': 90,
            'left': 30,
            'fontSize': 14,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#000',
            'active': false,
            'type': 'input',
            'value': '公司介绍：我们是一家XX公司，提供XXX货品'
        },
        {
            'width': 50,
            'height': 20,
            'top': 135,
            'left': 27,
            'draggable': true,
            'resizable': true,
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img',
            'src': '/static/image/poster/good_tip.png'
        },
        {
            'width': 200,
            'height': 80,
            'top': 160,
            'left': 28,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'good',
            'info': {
                'goods_name': '东北大米',
                'img': '/static/image/boluo_icon.jpg',
                'goods_format_name': '20kg/袋',
                'min_order_amount': '2',
                'goods_sales_unit_name': '袋',
                'goods_sales': '3',
                'goods_price': '22'
            }
        },
        {
            'width': 50,
            'height': 50,
            'top': 252,
            'left': 102,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img_qrcode',
            'src': '/static/image/poster/poster_qrcode.png'
        },
        {
            'width': 180,
            'height': 25,
            'top': 310,
            'left': 58,
            'fontSize': 10,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#fff',
            'active': false,
            'type': 'input',
            'value': '长按二维码，进入商城'
        },
    ],
    [{
            'width': 60,
            'height': 60,
            'top': 10,
            'left': 100,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img',
            'src': '/static/image/poster/poster_icon.png'
        },
        {
            'width': 180,
            'height': 40,
            'top': 90,
            'left': 30,
            'fontSize': 14,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#000',
            'active': false,
            'type': 'input',
            'value': '公司介绍：我们是一家XX公司，提供XXX货品'
        },
        {
            'width': 50,
            'height': 20,
            'top': 140,
            'left': 30,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img',
            'src': '/static/image/poster/activity_tip.png'
        },
        {
            'width': 200,
            'height': 70,
            'top': 165,
            'left': 30,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'activity',
            'info': {
                'rule_show': '满20减3',
                'start_date': '2022-03-01',
                'end_date': '2022-03-31',
            }
        },
        {
            'width': 50,
            'height': 50,
            'top': 252,
            'left': 102,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false,
            'type': 'img_qrcode',
            'src': '/static/image/poster/poster_qrcode.png'
        },
        {
            'width': 180,
            'height': 25,
            'top': 310,
            'left': 58,
            'fontSize': 10,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#fff',
            'active': false,
            'type': 'input',
            'value': '长按二维码，进入商城'
        },
    ]
];
var generateRects = function () {
    return _.cloneDeep(defaultRects).map(function (rect) {
        rect.forEach(function (item) {
            item.id = _.uniqueId();
        });
        return rect;
    });
};
var ShopActivityAdd = (function (_super) {
    __extends(ShopActivityAdd, _super);
    function ShopActivityAdd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.temp = [0, 0];
        _this.action = "/supplierapi/upload";
        _this.showCloseBtn = false;
        _this.showDialog = false;
        _this.title = '';
        _this.categoryList = [];
        _this.selectDate = {};
        _this.canvasPath = '';
        _this.release = 0;
        _this.showDiv = false;
        _this.FormModel = [];
        _this.searchData = {};
        _this.tableColumnList = [];
        _this.template_type = 1;
        _this.imgIndex = 0;
        _this.template_pic = [
            {
                name: '模板一',
                src: '/static/image/poster/shop.png'
            },
            {
                name: '模板二',
                src: '/static/image/poster/good.png'
            },
            {
                name: '模板三',
                src: '/static/image/poster/activity.png'
            }
        ];
        _this.rects = generateRects();
        _this.isFocus = false;
        return _this;
    }
    ShopActivityAdd.prototype.created = function () {
        this.Service = ShopActivityService.getInstance();
        this.getshopConfig();
        if (this.poster_id) {
            this.getUpdateTemplat();
        }
    };
    ShopActivityAdd.prototype.getshopConfig = function () {
        var _this = this;
        this.Service.configShow().then(function (res) {
            _this.shop_website = 'https://' + res.data.data.shop_website;
        });
    };
    ShopActivityAdd.prototype.getUpdateTemplat = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.Service.detail({ poster_id: this.poster_id }).then(function (res) {
            loadingInstance.close();
            if (res.data.data) {
                var DATA = res.data.data;
                _this.template_type = DATA.poster_type;
                _this.rects[_this.template_type - 1] = JSON.parse(DATA.poster_data);
                _this.poster_id = DATA.poster_id;
                if (DATA.poster_type == 2) {
                    _this.selectDate.goods_id = DATA.poster_relate_id;
                }
                else if (DATA.poster_type == 3) {
                    _this.selectDate.activity_id = DATA.poster_relate_id;
                }
                _this.$forceUpdate();
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ShopActivityAdd.prototype.deleteItem = function (index) {
        var rectIndex = this.template_type - 1;
        if (this.rects[rectIndex])
            this.rects[rectIndex].splice(index, 1);
    };
    ShopActivityAdd.prototype.change_template = function (id) {
        this.rects = generateRects();
        this.template_type = id;
    };
    ShopActivityAdd.prototype.activateEv = function (index) {
    };
    ShopActivityAdd.prototype.deactivateEv = function (newRect, index) {
    };
    ShopActivityAdd.prototype.changePosition = function (newRect, index) {
        this.rects[this.template_type - 1][index].height = newRect.height;
        this.rects[this.template_type - 1][index].width = newRect.width;
        this.rects[this.template_type - 1][index].left = newRect.left;
        this.rects[this.template_type - 1][index].top = newRect.top;
    };
    ShopActivityAdd.prototype.changeSize = function (newRect, index) {
        this.rects[this.template_type - 1][index].height = newRect.height;
        this.rects[this.template_type - 1][index].width = newRect.width;
        this.rects[this.template_type - 1][index].left = newRect.left;
        this.rects[this.template_type - 1][index].top = newRect.top;
        this.$forceUpdate();
    };
    ShopActivityAdd.prototype.uploadSuccess = function (response, file, fileList) {
        var that = this;
        if (response) {
            var imgUrl = response.data.full_path;
            window.URL = window.URL || window.webkitURL;
            var xhr = new XMLHttpRequest();
            xhr.open("get", imgUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (this.status == 200) {
                    var blob = this.response;
                    var oFileReader = new FileReader();
                    oFileReader.onloadend = function (e) {
                        var base64 = e.target.result;
                        console.log("方式一》》》》》》》》》", base64);
                        that.rects[that.template_type - 1][that.imgIndex].src = base64;
                        that.$forceUpdate();
                    };
                    oFileReader.readAsDataURL(blob);
                }
            };
            xhr.send();
        }
    };
    ShopActivityAdd.prototype.remove = function () {
    };
    ShopActivityAdd.prototype.beforeAvatarUpload = function (file) {
    };
    ShopActivityAdd.prototype.changeImg = function (index) {
        this.imgIndex = index;
        this.$refs["uploadImg" + index][0].$refs['upload-inner'].handleClick();
    };
    ShopActivityAdd.prototype.addText = function () {
        this.rects[this.template_type - 1].push({
            'closeable': true,
            'width': 180,
            'height': 40,
            'top': 0,
            'left': 0,
            'fontSize': 14,
            'draggable': true,
            'resizable': true,
            'minw': 100,
            'minh': 100,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#000',
            'active': false,
            'type': 'input',
            'value': '公司介绍：我们是一家XX公司，提供XXX货品'
        });
        this.$forceUpdate();
    };
    ShopActivityAdd.prototype.addUploadSuccess = function (response, file, fileList) {
        var that = this;
        if (response) {
            var imgUrl = response.data.full_path;
            window.URL = window.URL || window.webkitURL;
            var xhr = new XMLHttpRequest();
            xhr.open("get", imgUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (this.status == 200) {
                    var blob = this.response;
                    var oFileReader = new FileReader();
                    oFileReader.onloadend = function (e) {
                        var base64 = e.target.result;
                        that.addImage(base64);
                    };
                    oFileReader.readAsDataURL(blob);
                }
            };
            xhr.send();
        }
    };
    ShopActivityAdd.prototype.addImage = function (url) {
        var _this = this;
        var _a = [60, 60], width = _a[0], height = _a[1];
        var img = new Image();
        img.src = url;
        img.onload = function () {
            if (img.width && img.height) {
                var ratio = Math.ceil(img.width / width);
                height = img.height / ratio;
            }
            _this.rects[_this.template_type - 1].push({
                'closeable': true,
                'width': width,
                'height': height,
                'top': 0,
                'left': 0,
                'draggable': true,
                'resizable': true,
                'minw': 100,
                'minh': 100,
                'axis': 'both',
                'parentLim': true,
                'snapToGrid': false,
                'aspectRatio': false,
                'zIndex': 1,
                'color': '#EF9A9A',
                'active': false,
                'type': 'img',
                'src': url
            });
        };
    };
    ShopActivityAdd.prototype.addgoodOrActivity = function (type, index) {
        this.showDialog = true;
        this.goodOrActivityIndex = index;
        if (type == 1) {
            this.getCategory();
            if (index == undefined) {
                this.goodOrActivityIndex = this.rects[this.template_type - 1].findIndex(function (item) { return item.type == 'good'; });
            }
            this.title = '添加货品';
            this.actionUrl = this.Service.getGoods;
            this.tableColumnList = [
                { "prop": "goods_name", "propName": "货品名称" },
                { "prop": "goods_code", "propName": "货品编码" },
                { "prop": "goods_format_name", "propName": "规格" },
                { "prop": "goods_sales_unit_name", "propName": "单位" },
            ];
            this.FormModel = [
                {
                    label: '1',
                    prop: 'goods_type',
                    type: 'selectTree',
                    props: {
                        placeholder: '选择货品分类',
                        normalizer: ['goods_type_id', 'goods_type_name']
                    }
                },
                {
                    label: '2',
                    prop: 'keyword',
                    type: 'input',
                    props: {
                        placeholder: '请输入货品名称/首字母查询'
                    },
                },
            ];
            this.searchData = {
                goods_type: null,
                keyword: '',
                sales: 1
            };
        }
        else {
            this.getActTypeList();
            if (index == undefined) {
                this.goodOrActivityIndex = this.rects[this.template_type - 1].findIndex(function (item) { return item.type == 'activity'; });
            }
            this.title = '添加活动';
            this.actionUrl = this.Service.getActivityList;
            this.tableColumnList = [
                { "prop": "activity_code", "propName": "活动ID" },
                { "prop": "activity_name", "propName": "活动名称" },
                { "prop": "activity_type", "propName": "活动类型" },
                { "prop": "activity_date", "propName": "活动时间" },
            ];
            this.FormModel = [
                {
                    label: '状态',
                    prop: 'activity_type',
                    type: 'select',
                    props: {
                        placeholder: '请选择',
                        list: []
                    },
                },
                {
                    label: '2',
                    prop: 'keyword',
                    type: 'input',
                    props: {
                        placeholder: '请输入活动名称/首字母查询'
                    },
                },
            ];
            this.searchData = {
                activity_type: -1,
                keyword: '',
                status: 3,
                types: '1,2,3'
            };
        }
    };
    ShopActivityAdd.prototype.getActTypeList = function () {
        var _this = this;
        this.Service
            .getActTypeList({ types: '1,2,3' })
            .then(function (res) {
            var DATA = Array.isArray(res.data.data) ? res.data.data : [];
            DATA.forEach(function (item, index) {
                item.label = item.name;
            });
            _this.FormModel[0].props.list = DATA;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    ShopActivityAdd.prototype.getCategory = function () {
        var _this = this;
        this.Service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    ShopActivityAdd.prototype.closeDiolog = function () {
        this.showDialog = false;
    };
    ShopActivityAdd.prototype.saveGoodOrActivity = function (data) {
        this.showDialog = false;
        this.selectDate = data;
        this.rects[this.template_type - 1][this.goodOrActivityIndex].info = data;
        if (this.template_type == 2) {
            data.main_pic.length !== 0 ? this.rects[this.template_type - 1][this.goodOrActivityIndex].info.img = data.main_pic : this.rects[this.template_type - 1][this.goodOrActivityIndex].info.img = '/static/image/boluo_icon.jpg';
            this.rects[this.template_type - 1][this.goodOrActivityIndex].info.min_order_amount = parseFloat(this.rects[this.template_type - 1][this.goodOrActivityIndex].info.min_order_amount);
        }
        else {
            this.rects[this.template_type - 1][this.goodOrActivityIndex].info.start_date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(this.rects[this.template_type - 1][this.goodOrActivityIndex].info.start_date)[0];
            this.rects[this.template_type - 1][this.goodOrActivityIndex].info.end_date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(this.rects[this.template_type - 1][this.goodOrActivityIndex].info.end_date)[0];
        }
    };
    ShopActivityAdd.prototype.inputFocus = function (index) {
        switch (this.template_type) {
            case 1:
                this.$refs["focusTextarea" + index][0].focus();
                break;
            case 2:
                this.$refs["focusTextareaG" + index][0].focus();
                break;
            case 3:
                this.$refs["focusTextareaA" + index][0].focus();
                break;
        }
        this.isFocus = true;
    };
    ShopActivityAdd.prototype.handleBlur = function () {
        this.isFocus = false;
    };
    ShopActivityAdd.prototype.savePoster = function (release) {
        var _this = this;
        this.showDiv = true;
        if (!this.selectDate) {
            if (this.template_type == 2) {
                this.$message.error('请选择活动货品');
                return;
            }
            else if (this.template_type == 3) {
                this.$message.error('请选择活动');
                return;
            }
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        document.getElementById('qrcodeImg' + this.template_type).style.display = 'none';
        var deleteIcons = document.querySelectorAll('.drag-item-delete') || [];
        Array.from(deleteIcons).forEach(function (icon) { return icon.style.display = 'none'; });
        if (this.template_type == 3) {
            switch (this.selectDate.activity_type) {
                case '满减':
                    this.activityTypeUrl = '/activity/fullminuslist?';
                    break;
                case '满赠':
                    this.activityTypeUrl = '/activity/fullgiftlist?';
                    break;
                case '赠品':
                    this.activityTypeUrl = '/activity/giftlist?';
                    break;
                case '返利':
                    this.activityTypeUrl = '/activity/rebatelist?';
                    break;
            }
        }
        var qrcodeImgEl_one = document.getElementById('qrcodeImg' + this.template_type);
        var qrcode1 = new QRCode(qrcodeImgEl_one, {
            width: 285,
            height: 285,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H,
            text: this.template_type == 1 ? this.shop_website : this.template_type == 2 ? this.shop_website + '/goods/' + this.selectDate.goods_id : this.shop_website + this.activityTypeUrl + 'activityId=' + this.selectDate.activity_id,
        });
        this.timer2 = setTimeout(function () {
            document.getElementById('qrcodeImg' + _this.template_type).style.display = 'none';
            var qrcode = _this.rects[_this.template_type - 1].filter(function (item) {
                return item.type == 'img_qrcode';
            });
            qrcode[0].src = document.getElementById('qrcodeImg' + _this.template_type).children[1].getAttribute('src');
            clearTimeout(_this.timer2);
            _this.release = release;
            var that = _this;
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            var node = document.getElementById(_this.template_type == 1 ? 'mycanvas_shop' : _this.template_type == 2 ? 'mycanvas_good' : 'mycanvas_activity');
            var width = node.offsetWidth - 3;
            var height = node.offsetHeight;
            var scale = 2;
            html2canvas(node, {
                width: width,
                heigth: height,
                backgroundColor: "#ffffff",
                dpi: window.devicePixelRatio * 2,
                scale: scale,
                X: 0,
                Y: 0,
                scrollX: 0,
                scrollY: 0,
                useCORS: true,
                allowTaint: true
            }).then(function (canvas) {
                var url = canvas.toDataURL();
                var file = _this.base64toFile(url);
                var form = new FormData();
                form.append('file', file);
                $.ajax({
                    url: '/supplierapi/upload',
                    type: 'POST',
                    data: form,
                    async: false,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        that.canvasPath = res.data.full_path;
                        loadingInstance.close();
                        that.saveAll();
                    },
                    error: function (err) {
                        loadingInstance.close();
                        this.$message.error(err.msg || err.message);
                    }
                });
            });
        }, 2000);
    };
    ShopActivityAdd.prototype.base64toFile = function (imageBase64, filename) {
        if (filename === void 0) { filename = 'file'; }
        var arr = imageBase64.split(',');
        var binary = atob(arr[1]);
        var mine = arr[0].match(/:(.*?);/)[1];
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        var blob = new Blob([new Uint8Array(array)], { type: mine });
        var file = new File([blob], Date.now() + '.png', { type: mine });
        return file;
    };
    ShopActivityAdd.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.Service.configShow({}).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.template_type = res.data.data.poster_type;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ShopActivityAdd.prototype.saveAll = function () {
        var _this = this;
        var poster_relate_id = '';
        if (this.template_type == 2) {
            poster_relate_id = this.selectDate.goods_id;
        }
        else if (this.template_type == 3) {
            poster_relate_id = this.selectDate.activity_id;
        }
        if (this.poster_id) {
            var params = {
                poster_id: this.poster_id,
                poster_type: this.template_type,
                poster_data: JSON.stringify(this.rects[this.template_type - 1]),
                poster_relate_id: poster_relate_id,
                poster_url: this.canvasPath,
                release: this.release
            };
            this.Service.update(params).then(function (res) {
                _this.$message.success('操作成功');
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 500);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            var params = {
                poster_type: this.template_type,
                poster_data: JSON.stringify(this.rects[this.template_type - 1]),
                poster_relate_id: poster_relate_id,
                poster_url: this.canvasPath,
                release: this.release
            };
            this.Service.addPoster(params).then(function (res) {
                _this.$message.success('操作成功');
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 500);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    ShopActivityAdd.prototype.beforeDestroy = function () {
        this.timer && clearTimeout(this.timer);
        this.timer2 && clearTimeout(this.timer2);
    };
    ShopActivityAdd = __decorate([
        Component({
            components: {
                TableListDialog: TableListDialog,
                VueDragResize: VueDragResize,
                DragItem: DragItem,
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], ShopActivityAdd);
    return ShopActivityAdd;
}(Vue));
export default ShopActivityAdd;
